var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5181 18.4203C49.9254 13.7499 59.5879 11.0653 69.8719 11V32.1744C68.9712 32.3319 68.1821 32.8141 67.6298 33.4959L41.5181 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5924 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 37.1628L97.5762 50.7844C98.1288 50.098 98.9208 49.6124 99.8253 49.4542L99.8253 19.271L73.8777 34.2519C74.1031 34.7309 74.2292 35.266 74.2292 35.8306C74.2292 36.3001 74.142 36.7493 73.9829 37.1628Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8989 11.0021C81.1404 11.1104 90.759 13.8166 99.127 18.4928L73.3185 33.3933C72.7162 32.702 71.862 32.2359 70.8989 32.1379V11.0021Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1036 34.373L40.9465 19.2712L40.9465 49.418C41.9136 49.5164 42.7708 49.986 43.3736 50.682L67.0069 37.0373C66.8769 36.659 66.8064 36.2532 66.8064 35.8308C66.8064 35.3133 66.9123 34.8206 67.1036 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.3411C31.4054 24.4266 24.2705 31.5888 19.2178 40.1287L37.6745 50.7847C38.2271 50.0983 39.019 49.6127 39.9236 49.4545L39.9236 19.3411Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0144C13.9327 49.4028 11.1518 59.0691 11 69.3721L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1107C36.8533 52.5972 36.9576 52.108 37.1462 51.6632L18.7019 41.0144Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 84.0145V56.7672C38.9323 56.5943 38.0783 56.0303 37.5241 55.2406L11.5049 70.2628L37.6578 85.3622C38.211 84.6665 39.0087 84.174 39.9209 84.0145Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1533C11.1518 81.4564 13.9327 91.1226 18.7019 99.5111L37.0649 88.9091C36.9279 88.5218 36.8533 88.105 36.8533 87.6707C36.8533 87.1651 36.9544 86.6831 37.1375 86.2438L11 71.1533Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9426 91.1553 38.0941 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8719 129.526C59.5879 129.46 49.9254 126.776 41.5181 122.105L67.4944 107.108C68.049 107.883 68.8948 108.436 69.8719 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0863 103.534L43.5154 89.9254C42.9094 90.7168 41.9922 91.2571 40.9465 91.3635L40.9465 121.254L67.0218 106.2C66.8823 105.809 66.8064 105.389 66.8064 104.951C66.8064 104.449 66.9059 103.971 67.0863 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 122.033C90.759 126.709 81.1404 129.415 70.8989 129.523V108.643C71.9406 108.537 72.855 108.001 73.461 107.214L99.127 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.443 89.8187L73.8979 103.412C74.1117 103.881 74.2307 104.402 74.2307 104.951C74.2307 105.436 74.1376 105.9 73.9681 106.325L99.8269 121.254V91.3271C98.8459 91.1556 97.9974 90.5989 97.443 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2571 102.814 90.7168 103.42 89.9254L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0775 121.878 99.3995L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5934 103.846 86.1221L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5537 103.293 85.2591L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4097 70.2629L97.5626 85.3623C98.1158 84.6667 98.9135 84.1741 99.8257 84.0146V70.2629L71.4097 70.2629Z",
    fill: "#037C84"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_19560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6234 100.114C72.6234 100.114 75.468 104.293 81.4299 107.83C81.4299 107.83 77.1121 71.3378 105.246 65C98.0379 91.4545 114.415 98.9151 120.384 84.9387C130.354 98.249 122.784 109.861 122.784 109.861C126.872 110.45 130.306 105.984 130.306 105.984C130.337 106.535 130.354 107.089 130.354 107.646C130.354 123.858 117.212 137 101 137C84.7884 137 71.6462 123.858 71.6462 107.646C71.6462 105.042 71.9871 102.518 72.6234 100.114Z",
    fill: "#FF6536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.306 105.984C130.306 105.984 126.872 110.45 122.784 109.861C122.784 109.861 130.354 98.249 120.384 84.9387C114.415 98.9151 98.038 91.4545 105.246 65C103.739 65.3395 102.326 65.766 101 66.2682V137C117.212 137 130.354 123.858 130.354 107.646C130.354 107.088 130.337 106.535 130.306 105.984Z",
    fill: "#FF421D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1267 124.127C88.1267 131.236 93.8904 137 101 137C108.11 137 113.873 131.236 113.873 124.127C113.873 120.321 112.222 116.901 109.597 114.545C104.62 121.307 97.5272 111.049 103.055 103.559C103.055 103.559 88.1267 105.43 88.1267 124.127Z",
    fill: "#FBBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.873 124.127C113.873 120.321 112.222 116.901 109.597 114.545C104.62 121.307 97.5271 111.049 103.055 103.559C103.055 103.559 102.244 103.661 101 104.053V137C108.11 137 113.873 131.236 113.873 124.127Z",
    fill: "#FFA900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_19560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(65 65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnergy);
export default __webpack_public_path__ + "static/media/Logo_energy.34a9b478294b1720f207aca0e5031b29.svg";
export { ForwardRef as ReactComponent };